import React from 'react';
import { AlertCircle, Clock, Users, Calendar } from 'lucide-react';

const ProblemSection = () => {
  const problems = [
    {
      icon: AlertCircle,
      title: "Missing Customer Calls & Messages",
      description: "Customers reach out when you're busy, and by the time you respond, they've already gone to your competitor"
    },
    {
      icon: Users,
      title: "Customer Data Scattered Everywhere",
      description: "Your customer information is spread across emails, spreadsheets, and different systems - making it impossible to get the full picture"
    },
    {
      icon: Calendar,
      title: "Scheduling Chaos & No-Shows",
      description: "Double bookings, missed appointments, and constant back-and-forth trying to find a time that works for everyone"
    }
  ];

  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-black to-gray-900/50 md:bg-gradient-to-b md:from-black md:to-gray-900/50 from-purple-900/20 via-black to-blue-900/10" aria-labelledby="problems-heading">
      <div className="max-w-6xl mx-auto text-center">
        {/* Section Title */}
        <h2 id="problems-heading" className="text-3xl sm:text-4xl md:text-5xl font-display text-white mb-12 sm:mb-16 tracking-wide">
          Problems We{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-300 to-purple-400">
            Solve
          </span>
        </h2>

        {/* Problems Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16" role="list">
          {problems.map((problem, index) => {
            const IconComponent = problem.icon;
            return (
              <div
                key={index}
                className="group p-6 sm:p-8 rounded-2xl bg-gray-900/30 md:bg-gray-900/30 bg-purple-800/20 border border-gray-800/50 md:border-gray-800/50 border-purple-400/30 hover:border-gray-400/30 md:hover:border-gray-400/30 hover:border-purple-300/50 transition-all duration-300 hover:bg-gray-900/50 md:hover:bg-gray-900/50 hover:bg-purple-700/30 backdrop-blur-sm mobile-card-glow hover:scale-105"
                role="listitem"
              >
                <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 bg-gradient-to-r from-gray-400/20 to-purple-600/20 md:from-gray-400/20 md:to-purple-600/20 from-purple-500/30 to-blue-500/30 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 mobile-card-glow">
                  <IconComponent className="w-8 h-8 sm:w-10 sm:h-10 text-gray-300 md:text-gray-300 mobile-accent-purple" aria-hidden="true" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white md:text-white mobile-accent-white mb-3 sm:mb-4 font-robotic mobile-text-glow">
                  {problem.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-400 md:text-gray-400 mobile-accent-silver leading-relaxed font-tech">
                  {problem.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a
            href="#solutions" 
            className="group relative inline-block px-10 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-gray-500 to-purple-600 hover:from-gray-600 hover:to-purple-700 rounded-2xl text-white font-bold text-lg sm:text-xl tracking-wide transition-all duration-300 hover:scale-105 active:scale-95 hover:shadow-2xl hover:shadow-purple-600/30"
            aria-label="View our AI solutions"
          >
            <span className="relative z-10 font-robotic">See Our Solutions</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;